import styled from 'styled-components';

export default styled.hr`
	margin: 2rem auto 3rem;
`;
